import React from 'react';

import PageLayout from '../../components/blocks/page-layout';
import { TermsOfSaleNl } from '../../policies/terms-nl';
import { useTranslate } from '../../hooks/useTranslate';
import { useLocale } from '../../hooks/useLocale';
import { TermsOfSaleFr } from '../../policies/terms-fr';

export default function Page() {
  const translate = useTranslate();
  const locale = useLocale();

  return (
    <PageLayout title={translate('policies.termsOfSale')}>
      {locale === 'fr' ? <TermsOfSaleFr /> : <TermsOfSaleNl />}
    </PageLayout>
  );
}
